import React from 'react';
import { useDispatch } from 'react-redux';
import { useDrop } from 'react-dnd';
import PropTypes from 'prop-types';

import EmptyState from './EmptyState';
import * as canvasActions from '../../actions/canvasBlocks';
import * as itemTypes from '../../constants/itemTypes/itemTypes';
import * as Styled from './styles';

const EmptyBlockDropZone = ({ shouldRender }) => {
    const dispatch = useDispatch();

    const [{ isOverCurrent }, drop] = useDrop({
        accept: itemTypes.STATIC_BLOCK,
        drop: ({ newBlock }) => {
            dispatch(
                canvasActions.addBlock({
                    block: newBlock,
                })
            );
        },
        collect: (monitor) => ({
            isOverCurrent: monitor.isOver({ shallow: true }),
        }),
    });

    if (!shouldRender) {
        return null;
    }

    return (
        <div ref={drop}>
            <Styled.DropZone isOverCurrent={isOverCurrent}>
                <div style={{ width: '100%', color: '#656566', textAlign: 'center', margin: '46px 0' }}>
                    {isOverCurrent ? (
                        <Styled.DropZoneText>Drop block here</Styled.DropZoneText>
                    ) : (
                        <Styled.EmptyStateDiv>
                            <EmptyState />
                            <Styled.EmptyStateText>Click or drag a block layout to get started.</Styled.EmptyStateText>
                        </Styled.EmptyStateDiv>
                    )}
                </div>
            </Styled.DropZone>
        </div>
    );
};

EmptyBlockDropZone.propTypes = {
    shouldRender: PropTypes.bool.isRequired,
};

export default EmptyBlockDropZone;
